

// ReSharper disable InconsistentNaming
// ReSharper disable StringLiteralWrongQuotes
/* tslint:disable:no-use-before-declare quotemark max-line-length */
import { IApiAction } from '../utils/data-service';
export namespace Models {
	/**
	 * To improve build and incremental build times we transpile modules using TS transpileOnly mode. It essentially builds one file at a time
	 * Using transpileOnly with emitDecoratorMetadata flag sometimes causes issues when a type or an interface is used as a property type on a decorated property
	 * Example typescript:
	 * import {Models} from '../ags-generated';
	 * import AgsViewModel = Models.AgsViewModel;
	 * export class AgsStore {
	 *   @observable model: AgsViewModel;
	 * }
	 * Generated javascript:
	 * var ags_generated_1 = __webpack_require__(<webpackModuleId>);
	 * var AgsViewModel = ags_generated_1.Models.AgsViewModel;
	 * the previous line will result in runtime error if Models does not export anything
	 * In order to avoid runtime errors accessing undefined Models let's export dummy variable
	 */
	export const __dummy = true;
	export enum ExportAction {
		View = 0, Csv = 1, Excel = 2, ExcelMultiMerchant = 3, Custom = 4,
	}
	export interface CheckAllocationEditModel {
		BatchId: number;
		EncodedToken: string;
		PaymentVersion: number;
		MerchantVersion: number;
		CommunityMemberId: number;
		WantsTransactionNotifications: boolean;
		YourId: string;
		CommonPaymentFields: CommonPaymentFieldsModel;
		Splits: CheckSplitEditModel[];
	}
	export interface CheckSplitEditModel {
		Fund: CustomFieldEditModel;
		Amount: number;
		CampusKey: string;
		FundValidationErrorMessage: string;
		AmountValidationErrorMessage: string;
	}
	export interface CustomFieldEditModel {
		Key: string;
		Type: CustomFieldType;
		Value: string;
	}
	export enum CustomFieldType {
		Unknown = 0, Text = 1, Number = 2, DropDown = 3, Fund = 4, Campus = 5,
	}
	export interface CommonPaymentFieldsModel {
		ReferenceFieldValues: CustomFieldEditModel[];
		GivenOn: Date;
		Notes: string;
	}
	export interface PaymentBatchSpeedSettings {
		FundKey: string;
		GivenOn: Date;
	}
	export interface CheckAllocationViewModel {
		RowNumber: number;
		EncodedToken: string;
		PaymentVersion: number;
		Amount: number;
		RoutingNumber: string;
		AccountNumber: string;
		CheckNumber: string;
		CheckImageUrl: string;
		FundName: string;
		HasMissingData: boolean;
		IsRead: boolean;
		YourId: string;
		CommunityMember: CommunityMemberQueryResult;
		WantsTransactionNotifications: boolean;
		CommonPaymentFields: CommonPaymentFieldsModel;
		Splits: CheckSplitEditModel[];
	}
	export interface CommunityMemberQueryResult {
		CommunityMemberId: number;
		PrimaryExternalId: string;
		CampusName: string;
		FirstName: string;
		LastName: string;
		EmailAddress: string;
		MobileNumber: string;
		Address: CommunityAddressModel;
		TimeZoneId: string;
		LastPaymentOnUtc: Date;
		LastPaymentOnLocal: Date;
		LockVersion: number;
		CommunityMemberType: CommunityMemberType;
	}
	export enum CommunityMemberType {
		Unknown = 0, Individual = 1, Organization = 2,
	}
	export interface CommunityAddressModel {
		Line1: string;
		Line2: string;
		City: string;
		State: string;
		Postcode: string;
		Country: Country;
		DisplayAddress: string;
		PostalCodeLabel: string;
	}
	export enum Country {
		NZ = 0, AU = 1, US = 2, AF = 4, AL = 8, AQ = 10, DZ = 12, AS = 16, AD = 20, AO = 24, AG = 28, AZ = 31, AR = 32, AT = 40, BS = 44, BH = 48, BD = 50, AM = 51, BB = 52, BE = 56, BM = 60, BT = 64, BO = 68,
		BA = 70, BW = 72, BV = 74, BR = 76, BZ = 84, IO = 86, SB = 90, VG = 92, BN = 96, BG = 100, MM = 104, BI = 108, BY = 112, KH = 116, CM = 120, CA = 124, CV = 132, KY = 136, CF = 140, LK = 144, TD = 148, CL = 152,
		CN = 156, TW = 158, CX = 162, CC = 166, CO = 170, KM = 174, YT = 175, CG = 178, CD = 180, CK = 184, CR = 188, HR = 191, CU = 192, CY = 196, CZ = 203, BJ = 204, DK = 208, DM = 212, DO = 214, EC = 218, SV = 222,
		GQ = 226, ET = 231, ER = 232, EE = 233, FO = 234, FK = 238, GS = 239, FJ = 242, FI = 246, AX = 248, FR = 250, GF = 254, PF = 258, TF = 260, DJ = 262, GA = 266, GE = 268, GM = 270, PS = 275, DE = 276, GH = 288,
		GI = 292, KI = 296, GR = 300, GL = 304, GD = 308, GP = 312, GU = 316, GT = 320, GN = 324, GY = 328, HT = 332, HM = 334, VA = 336, HN = 340, HK = 344, HU = 348, IS = 352, IN = 356, ID = 360, IR = 364, IQ = 368,
		IE = 372, IL = 376, IT = 380, CI = 384, JM = 388, JP = 392, KZ = 398, JO = 400, KE = 404, KP = 408, KR = 410, KW = 414, KG = 417, LA = 418, LB = 422, LS = 426, LV = 428, LR = 430, LY = 434, LI = 438, LT = 440,
		LU = 442, MO = 446, MG = 450, MW = 454, MY = 458, MV = 462, ML = 466, MT = 470, MQ = 474, MR = 478, MU = 480, MX = 484, MC = 492, MN = 496, MD = 498, ME = 499, MS = 500, MA = 504, MZ = 508, OM = 512, NA = 516,
		NR = 520, NP = 524, NL = 528, CW = 531, AW = 533, SX = 534, BQ = 535, NC = 540, VU = 548, NI = 558, NE = 562, NG = 566, NU = 570, NF = 574, NO = 578, MP = 580, UM = 581, FM = 583, MH = 584, PW = 585, PK = 586,
		PA = 591, PG = 598, PY = 600, PE = 604, PH = 608, PN = 612, PL = 616, PT = 620, GW = 624, TL = 626, PR = 630, QA = 634, RE = 638, RO = 642, RU = 643, RW = 646, BL = 652, SH = 654, KN = 659, AI = 660, LC = 662,
		MF = 663, PM = 666, VC = 670, SM = 674, ST = 678, SA = 682, SN = 686, RS = 688, SC = 690, SL = 694, SG = 702, SK = 703, VN = 704, SI = 705, SO = 706, ZA = 710, ZW = 716, ES = 724, SS = 728, SD = 729, EH = 732,
		SR = 740, SJ = 744, SZ = 748, SE = 752, CH = 756, SY = 760, TJ = 762, TH = 764, TG = 768, TK = 772, TO = 776, TT = 780, AE = 784, TN = 788, TR = 792, TM = 795, TC = 796, TV = 798, UG = 800, UA = 804, MK = 807,
		EG = 818, GB = 826, GG = 831, JE = 832, IM = 833, TZ = 834, VI = 850, BF = 854, UY = 858, UZ = 860, VE = 862, WF = 876, WS = 882, YE = 887, ZM = 894, XK = 999, __ = -2, Unsupported = -1,
	}
	export interface GetLastPaymentDetailsRequestModel {
		BatchId: number;
		EncodedToken: string;
		CommunityMemberId: number;
	}
	export interface GetLastPaymentDetailsResponseModel {
		ReferenceFieldValues: CustomFieldEditModel[];
		YourId: string;
		WantsTransactionNotifications: boolean;
	}
	export interface CheckImageStats {
		NavigationStart: Date;
		TimeSinceNavigationStart: number;
		BatchId: number;
		EncodedPaymentToken: string;
		CheckImageState: CheckImageState;
		CheckImageSource: CheckImageSource;
	}
	export enum CheckImageSource {
		AllocationForm = 0, AddNewCommunityMemberDialog = 1,
	}
	export enum CheckImageState {
		Closed = 0, Front = 1, Back = 2,
	}
	export interface CheckAllocationStats {
		NavigationStart: Date;
		TimeCheckAllocationOpen: number;
		TimeSinceNavigationStart: number;
		PayerSearchCount: number;
		HadMissingData: boolean;
		HadMissingPayer: boolean;
		IsModified: boolean;
		PayersSelected: number;
		NewPayersSelected: number;
	}
	export enum CheckFormState {
		Open = 0, Closed = 1, Saved = 2,
	}
	export interface PayerSearchStats {
		BatchId: number;
		EncodedPaymentToken: string;
		NavigationStart: Date;
		TimeCheckAllocationOpen: number;
		TimePayerSelected: number;
		SelectedPayerIndex: number;
		SearchTermCharCount: number;
		SearchTermWordCount: number;
		IsNewPayer: boolean;
		CommunityMemberId: string;
	}
	export interface UiTimingStats {
		NavigationStart: Date;
		TimeSinceNavigationStart: number;
	}
	export interface BatchAllocationResultModel {
		BatchAlreadyAllocated: BatchAlreadyAllocatedModel;
		NumberOfChecksWithMissingData: number;
	}
	export interface BatchAlreadyAllocatedModel {
		AllocatedBy: string;
		AllocatedOn: Date;
	}
	export interface BatchesQueryModel {
		ListingIds: number[];
		CampusIds: number[];
		Status: BatchStatusFilter;
		FromDate: Date;
		ToDate: Date;
		SortBy: SortOrder;
		Page: number;
		TakeAllUpToCurrentPage: boolean;
	}
	export enum SortOrder {
		CreatedOnAsc = 0, CreatedOnDesc = 1, BatchNameAsc = 2, BatchNameDesc = 3, TotalAmountAsc = 4, TotalAmountDesc = 5,
	}
	export enum BatchStatusFilter {
		Pending = 0, Active = 1, PendingOrActive = 2, Closed = 3,
	}
	export interface BatchesViewModel {
		Batches: BatchItemViewModel[];
		TotalBatchCount: number;
		CanLoadMore: boolean;
	}
	export interface BatchItemViewModel {
		BatchId: number;
		BatchName: string;
		ListingName: string;
		Url: string;
		CreatedOn: Date;
		StatusLastChangedOn: Date;
		Total: number;
		NumberOfChecks: number;
		Status: UiBatchStatus;
		CreatedBy: string;
		LastUpdatedBy: string;
		CampusKey: string;
		CampusName: string;
	}
	export enum UiBatchStatus {
		Closed = 2, Populating = 3, Validating = 4, Reopened = 5, ReadyToAllocate = 6, Rejected = 7,
	}
	export interface PayerSearchForCheckRequestModel {
		BatchId: number;
		EncodedToken: string;
		Skip: number;
	}
	export interface PayerSearchRequestModel {
		Query: string;
		Skip: number;
	}
	export interface CommunityMemberLookupResult {
		HasMorePages: boolean;
		Results: CommunityMemberQueryResult[];
	}
	export interface EditCommunityMemberRequestModel {
		CommunityMemberId: number;
		FirstName: string;
		LastName: string;
		EmailAddress: string;
		MobileNumber: string;
		Address: CommunityAddressModel;
		LockVersion: number;
		CommunityMemberType: CommunityMemberType;
	}
	export interface CommunityMemberModel {
		CommunityMemberId: number;
		PrimaryExternalId: string;
		CampusName: string;
		FirstName: string;
		LastName: string;
		EmailAddress: string;
		MobileNumber: string;
		Address: CommunityAddressModel;
		TimeZoneId: string;
		LockVersion: number;
		LastPaymentOnUtc: Date;
		LastPaymentOnLocal: Date;
		LinkedPersons: PersonModel[];
		CommunityMemberType: CommunityMemberType;
		PaymentLabel: PaymentLabel;
	}
	export interface PaymentLabel {
		NounSentenceCase: string;
		NounPluralSentenceCase: string;
		VerbSentenceCase: string;
		VerbAppliedSentenceCase: string;
		NounLowerCase: string;
		NounPluralLowerCase: string;
		VerbLowerCase: string;
		VerbAppliedLowerCase: string;
		VerbPresentTenseSentenceCase: string;
		VerbPresentTenseLowerCase: string;
		VerbPastTenseSentenceCase: string;
		VerbPastTenseLowerCase: string;
		PayerSentenceCase: string;
		PayerLowerCase: string;
		PayerPluralSentenceCase: string;
		PayerPluralLowerCase: string;
		ActionSentenceCase: string;
		ActionLowerCase: string;
		ActionPluralSentenceCase: string;
		ActionPluralLowerCase: string;
		NonCashNounSentenceCase: string;
		NonCashNounLowerCase: string;
		NonCashPluralSentenceCase: string;
		NonCashPluralLowerCase: string;
		TextGivingFeatureName: string;
		GiftEntryFeatureName: string;
	}
	export interface PersonModel {
		PersonId: number;
		FirstName: string;
		LastName: string;
		EmailAddress: string;
		EmailAddressVerified: boolean;
		MobileNumber: string;
		MobileNumberVerified: boolean;
		Address: CommunityAddressModel;
		LastPaymentOnUtc: Date;
		LastPaymentOnLocal: Date;
		CommunityMemberType: CommunityMemberType;
	}
	export interface RegisteredScannersViewModel {
		RegisteredScanners: RegisteredScannerViewModel[];
		RegisterScannerDialogViewModel: RegisterScannerDialogViewModel;
		DeleteRegisteredScannerDialogViewModel: DeleteRegisteredScannerDialogViewModel;
	}
	export interface DeleteRegisteredScannerDialogViewModel {
		DeleteRegisteredScannerEndpoint: string;
	}
	export interface RegisterScannerDialogViewModel {
		RegisterNewScannerEndpoint: string;
		AvailableModels: string[];
		AccessibleCampuses: CampusSelectionItem[];
		IsCampusMappingEnabled: boolean;
	}
	export interface CampusSelectionItem {
		CampusId: number;
		CampusName: string;
	}
	export interface RegisteredScannerViewModel {
		Id: number;
		Model: string;
		SerialNumber: string;
		CampusName: string;
	}
	export interface RegisterScannerViewModel {
		Model: string;
		SerialNumber: string;
		CampusId: number;
	}
	export interface TransactionSummaryViewModel {
		PaymentId: number;
		PayerDisplayName: string;
		PayerDisplayEmail: string;
		PayerId: number;
		CreatedOn: Date;
		LegalGivenOnDateTimeOffset: Date;
		MerchantListingName: string;
		MerchantListingId: number;
		OrganizationId: number;
		AmountAsMoney: Money;
		IsCardPaymentRefund: boolean;
		IsCardPaymentRefunded: boolean;
		PaymentStatus: PaymentStatus;
		PaymentSource: PaymentSource;
		FundDisplayValue: string;
		References: KeyValuePair<String, String>[];
		PaymentReferences: MerchantTransactionReferenceSummary[];
		IsGuestPayer: boolean;
		IsRecurring: boolean;
		FundId: number;
		IsPaymentOnlyRole: boolean;
		PaymentCompensationInfo: PaymentCompensationInfo;
		SplitPaymentId: number;
		IsPartOfPaymentBatch: boolean;
		PaymentBatchId: number;
		PaymentBatchDisplay: string;
		SplitInfo: SplitPaymentAdditionalInfo;
		LinkToPayment: string;
		LinkToPayer: string;
		LinkToPaymentBatch: string;
		FundKey: string;
		FundCode: string;
		FundNotes: string;
	}
	export interface SplitPaymentAdditionalInfo {
		TotalAmount: Money;
		NumberOfSplits: number;
		SplitPaymentId: number;
	}
	export interface PaymentCompensationInfo {
		IsRelatedToCompensation: boolean;
		CompensationType: RefundType;
		IsOriginalPayment: boolean;
		OriginalPaymentId: number;
		CompensationPaymentId: number;
	}
	export enum RefundType {
		NotARefund = 0, CardPaymentRefund = 1, NzBankDishonour = 2, AchFailureCompensation = 3, CheckDepositReturnCompensation = 4, AchLateReturn = 5, CardChargeback = 6, AchRefund = 7, AchRefundFailureCompensation = 8,
		AchRefundLateReturn = 9, NonProcessed = 10,
	}
	export interface MerchantTransactionReferenceSummary {
		PaymentReferenceDefinitionId: number;
		PaymentReferenceValueId: number;
		ReferenceLabel: string;
		ReferenceValue: string;
		IsReadOnly: boolean;
	}
	export interface KeyValuePair<TKey, TValue> {
		Key: TKey;
		Value: TValue;
	}
	export enum PaymentSource {
		MobileApp = 0, HostedPaymentsPage = 1, LoggedInWeb = 2, ScheduledPayment = 3, Kiosk = 4, GuestAnticipatedPayment = 5, VirtualTerminal = 6, Fastpay = 7, Autopay = 8, TextGiving = 9, FastBillWeb = 10, CheckDeposit = 11,
		WebGiving = 12, TransactionImport = 13, BatchEntry = 14, EmbeddedGiving = 15, DirectProcessing = 16,
	}
	export enum PaymentStatus {
		New = 0, Processing = 1, Error = 2, Failed = 3, Success = 4, Expired = 5, Deleted = 6,
	}
	export interface Money {
		IsValid: boolean;
		Currency: Currency;
		Amount: number;
	}
	export enum Currency {
		NZD = 0, AUD = 1, USD = 2, CAD = 3, Unspecified = -1,
	}
	export interface TransactionSummaryAndFundTotalsViewModel {
		FetchTime: Date;
		FundTotals: BatchEntryFundTotal[];
		Transactions: TransactionSummaryViewModel[];
	}
	export interface BatchEntryFundTotal {
		FundKey: string;
		FundDisplayValue: string;
		FundCode: string;
		FundNotes: string;
		Total: Money;
	}
	export interface CheckAllocationBatchDetailsModel {
		BatchId: number;
		BatchVersionId: number;
		BatchName: string;
		BatchStatus: UiBatchStatus;
		MerchantName: string;
		MerchantId: number;
		CampusName: string;
		CampusKey: string;
		CreatedOn: Date;
		CreatedBy: string;
		StatusLastChangedOn: Date;
		UpdatedBy: string;
		NumberOfProcessibleChecks: number;
		TotalNumberOfChecks: number;
		TotalAmount: number;
		CustomFields: ICustomFieldViewModel[];
		BatchListUrl: string;
		MerchantVersion: number;
		AddMemberFormModel: AddCommunityMemberFormViewModel;
		PayButtonLabel: PaymentLabel;
		CheckSplittingEnabled: boolean;
		PayersReconciledMessage: string;
		ShowExportLabel: boolean;
		ExportLabel: string;
		ExportButtons: TransactionExportButton[];
		HasExportErrored: boolean;
		EnableFeatureOrganizationalGiving: boolean;
	}
	export interface TransactionExportButton {
		Action: ExportAction;
		Description: string;
		Label: string;
	}
	export interface AddCommunityMemberFormViewModel {
		MerchantId: number;
		DefaultCountry: Country;
	}
	export interface BatchesSummaryViewModel {
		HasBatches: boolean;
		Listings: MultiSelectItem[];
		Campuses: MultiSelectItem[];
		CampusListingsMappings: CampusListingsMappingModel[];
		NumberOfRegisteredScanners: number;
		RegisteredScannersRedirectUrl: string;
		PayButtonLabel: PaymentLabel;
		IsCheckScanningReadOnly: boolean;
		IsPaymentEntryOnlyRole: boolean;
		IsCampusMappingEnabled: boolean;
		CanAccessCheckScanningPortal: boolean;
		CheckScanningPortalAccess: CheckScanningPortalAccessInfo[];
		CheckDepositOverviewSupportUrl: string;
	}
	export interface CheckScanningPortalAccessInfo {
		CampusId: number;
		CampusKey: string;
		CampusName: string;
		ProfitStarsEntityId: number;
	}
	export interface CampusListingsMappingModel {
		CampusId: number;
		ListingIds: number[];
	}
	export interface MultiSelectItem {
		Text: string;
		SelectedText: string;
		Value: string;
		Disabled: boolean;
	}
	export interface FundCustomFieldViewModel {
		Key: string;
		Label: string;
		Placeholder: string;
		IsRequired: boolean;
		Type: CustomFieldType.Fund;
		DefaultOptionValue: string;
		Options: FundCustomFieldOptionViewModel[];
		Order: number;
	}
	export interface FundCustomFieldOptionViewModel {
		Label: string;
		Value: string;
		ForListing: boolean;
		CampusNameByKey: { [key: string]: string };
	}
	export interface DropDownCustomFieldViewModel {
		Key: string;
		Label: string;
		Placeholder: string;
		IsRequired: boolean;
		Type: CustomFieldType.DropDown;
		DefaultOptionValue: string;
		Options: DropDownCustomFieldOptionViewModel[];
		Order: number;
	}
	export interface DropDownCustomFieldOptionViewModel {
		Label: string;
		Value: string;
	}
	export interface NumberCustomFieldViewModel {
		Key: string;
		Label: string;
		Placeholder: string;
		IsRequired: boolean;
		Type: CustomFieldType.Number;
		MinLength: number;
		MaxLength: number;
		Order: number;
	}
	export interface TextCustomFieldViewModel {
		Key: string;
		Label: string;
		Placeholder: string;
		IsRequired: boolean;
		Type: CustomFieldType.Text;
		MinLength: number;
		MaxLength: number;
		Validation: TextFieldValidation;
		Order: number;
	}
	export enum TextFieldValidation {
		NoValidation = 0, LettersOnly = 1,
	}
	export type ICustomFieldViewModel = TextCustomFieldViewModel | NumberCustomFieldViewModel | DropDownCustomFieldViewModel | FundCustomFieldViewModel;
	export const CheckDepositApiConfig = {
		defaultBaseUrl: () => location.pathname.match(new RegExp('/pushpay/portal/\\d+', 'i'))[0],
		actions: {
			editCommunityMember: <IApiAction<{model: EditCommunityMemberRequestModel}, CommunityMemberModel>>{
				url: (data) => `/check-deposit/ajax/editCommunityMember`,
			},
			searchPayers: <IApiAction<{model: PayerSearchRequestModel}, CommunityMemberLookupResult>>{
				url: (data) => `/check-deposit/ajax/search-payers`,
			},
			searchPayersForCheck: <IApiAction<{model: PayerSearchForCheckRequestModel}, CommunityMemberLookupResult>>{
				url: (data) => `/check-deposit/ajax/search-payers-for-check`,
			},
			queryBatches: <IApiAction<{query: BatchesQueryModel}, BatchesViewModel>>{
				url: (data) => `/check-deposit/ajax/batches/query`,
			},
			completeBatch: <IApiAction<{batchId: number, uiTimingStats: UiTimingStats}, BatchAllocationResultModel>>{
				url: (data) => `/check-deposit/ajax/batch/complete`,
			},
			transactionSummaryForBatch: <IApiAction<{batchId: number}, TransactionSummaryAndFundTotalsViewModel>>{
				url: (data) => `/check-deposit/ajax/batch/transactionsummary`,
			},
			dismissRejectedBatch: <IApiAction<{batchId: number}, boolean>>{
				url: (data) => `/check-deposit/ajax/batch/dismiss-rejected`,
			},
			markCheckAsRead: <IApiAction<{batchId: number, encodedToken: string}, boolean>>{
				url: (data) => `/check-deposit/ajax/checkallocation/read`,
			},
			registerScanner: <IApiAction<{scanner: RegisterScannerViewModel}, RegisteredScannersViewModel>>{
				url: (data) => `/check-deposit/ajax/scanners/register`,
			},
			deleteScanner: <IApiAction<{scannerId: number}, RegisteredScannersViewModel>>{
				url: (data) => `/check-deposit/ajax/scanners/delete`,
			},
			logCheckScanningPortalWindowsCount: <IApiAction<{openCheckScanningPortalWindowsCount: number}, boolean>>{
				url: (data) => `/check-deposit/ajax/batch/log-open-check-scanning-portal-windows`,
			},
			logPayerSearchStats: <IApiAction<{model: PayerSearchStats}, boolean>>{
				url: (data) => `/check-deposit/ajax/allocation/log-payer-search-stats`,
			},
			logCheckAllocationState: <IApiAction<{batchId: number, encodedPaymentToken: string, formState: CheckFormState, model: CheckAllocationStats}, boolean>>{
				url: (data) => `/check-deposit/ajax/allocation/log-allocation-form-state`,
			},
			logCheckImageStats: <IApiAction<{model: CheckImageStats}, boolean>>{
				url: (data) => `/check-deposit/ajax/allocation/log-check-image-stats`,
			},
			getLastPaymentDetails: <IApiAction<{merchantId: number, model: GetLastPaymentDetailsRequestModel}, GetLastPaymentDetailsResponseModel>>{
				url: (data) => `/check-deposit/ajax/${data.merchantId}/last-payment-details`,
			},
			addCommunityMember: <IApiAction<{model: EditCommunityMemberRequestModel, merchantId: number}, CommunityMemberQueryResult>>{
				url: (data) => `/check-deposit/ajax/${data.merchantId}/AddCommunityMember`,
			},
			applySpeedSettingsWithSplits: <IApiAction<{merchantId: number, batchId: number, model: PaymentBatchSpeedSettings, uiTimingStats: UiTimingStats}, CheckAllocationViewModel[]>>{
				url: (data) => `/check-deposit/ajax/${data.merchantId}/batch/applySpeedSettings-with-splits`,
			},
			checkForBatchWithSplits: <IApiAction<{merchantId: number, batchId: number, encodedToken: string, uiTimingStats: UiTimingStats}, CheckAllocationViewModel>>{
				url: (data) => `/check-deposit/ajax/${data.merchantId}/batch/check-with-splits`,
			},
			checksForBatchWithSplits: <IApiAction<{merchantId: number, batchId: number, uiTimingStats: UiTimingStats}, CheckAllocationViewModel[]>>{
				url: (data) => `/check-deposit/ajax/${data.merchantId}/batch/checks-with-splits`,
			},
			saveSplitCheckAllocation: <IApiAction<{merchantId: number, model: CheckAllocationEditModel, stats: CheckAllocationStats}, CheckAllocationViewModel>>{
				url: (data) => `/check-deposit/ajax/${data.merchantId}/checkallocation/save-with-splits`,
			},
		},
		urls: {
		},
	};
	export const CheckDepositSsoApiConfig = {
		defaultBaseUrl: () => location.pathname.match(new RegExp('/pushpay/portal/\\d+', 'i'))[0],
		actions: {
		},
		urls: {
			byOrganization: (data) => `/check-deposit/sso-redirect`,
			byCampus: (data) => `/check-deposit/${data.campusKey}/sso-redirect`,
		},
	};
	export const CheckDepositExportConfig = {
		defaultBaseUrl: () => (<RegExpMatchArray>location.pathname.match(new RegExp('/pushpay/portal/\\d+', 'i')))[0],
		actions: {
			batchExport: <IApiAction<{batchId: number, button: ExportAction}>>{
				url: (data) => `/check-deposit/batch/export`,
			},
		},
		urls: {
		},
	};
}
/* tslint:enable:no-use-before-declare quotemark max-line-length */
// ReSharper restore InconsistentNaming
// ReSharper restore StringLiteralWrongQuotes
// ReSharper disable InconsistentNaming
// ReSharper disable StringLiteralWrongQuotes
/* tslint:disable:no-use-before-declare quotemark max-line-length */
export namespace ModelMetadata {
	export class MetadataArrayOf<T> {
		metadata: T;

		constructor(metadata: T) {
			this.metadata = metadata;
		}

		at(index: number): T {
			return this.metadata;
		}
	}

	export interface IPropertyMetadata {
		propertyName: string;
		displayName?: string;
		placeholder?: string;
		validationRules?: { [rule: string]: any };
		modelMetadata?: { [name: string] :IPropertyMetadata};
	}

	export let RegisterScannerViewModel = {
		Model: {
			propertyName: "Model",
			displayName: "Scanner make and model",
			validationRules: {
				length: {
					errorMessage: "The field Scanner make and model must be a string with a maximum length of 256.",
					parameters: {
						max: 256,
					},
				},
				required: {
					errorMessage: "The Scanner make and model field is required.",
				},
			},
		},
		SerialNumber: {
			propertyName: "SerialNumber",
			displayName: "Scanner serial number",
			validationRules: {
				length: {
					errorMessage: "The field Scanner serial number must be a string with a maximum length of 256.",
					parameters: {
						max: 256,
					},
				},
				required: {
					errorMessage: "The Scanner serial number field is required.",
				},
				skipsanitization: {},
			},
		},
		CampusId: {
			propertyName: "CampusId",
			validationRules: {
				number: {
					errorMessage: "The field CampusId must be a number.",
				},
			},
		},
	};
	export let ExportAction = {
	};
}
/* tslint:enable:no-use-before-declare quotemark max-line-length */
// ReSharper restore InconsistentNaming
// ReSharper restore StringLiteralWrongQuotes
